import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote, ChevronLeft, ChevronRight, Star } from 'lucide-react';
const testimonials = [{
  name: 'James Mitchell',
  role: 'CEO, TransfrInc',
  quote: 'Sage delivered a polished corporate website that perfectly captured our brand identity. His attention to detail and understanding of UX made the entire process seamless.',
  rating: 5
}, {
  name: 'Sarah van der Merwe',
  role: 'Founder, EcoMinim',
  quote: 'Working with Sage on our e-commerce platform was a great experience. He built a fast, responsive store that our customers love. Sales increased noticeably after launch.',
  rating: 5
}, {
  name: 'David Okonkwo',
  role: 'Director, BENS',
  quote: 'Sage developed a custom plugin that streamlined our operations significantly. He was communicative, professional, and delivered ahead of schedule.',
  rating: 5
}, {
  name: 'Lisa Chen',
  role: 'Marketing Lead, Cloudit',
  quote: 'Our new website has completely transformed how clients perceive our brand. Sage understood our vision from day one and executed it flawlessly.',
  rating: 5
}];
export function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent(c => c === 0 ? testimonials.length - 1 : c - 1);
  const next = () => setCurrent(c => c === testimonials.length - 1 ? 0 : c + 1);
  return <section id="testimonials" className="py-24 bg-dark relative" data-id="element-205">
      <div className="max-w-[1320px] mx-auto px-4" data-id="element-206">
        <div className="text-center mb-16" data-id="element-207">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-white font-syne mb-4" data-id="element-208">
            Client <span className="text-gold" data-id="element-209">Testimonials</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-white/60 font-inter max-w-lg mx-auto" data-id="element-210">
            What clients say about working with me.
          </motion.p>
        </div>

        <div className="max-w-3xl mx-auto relative" data-id="element-211">
          {/* Quote Icon */}
          <div className="flex justify-center mb-8" data-id="element-212">
            <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center border border-gold/20" data-id="element-213">
              <Quote className="w-7 h-7 text-gold" data-id="element-214" />
            </div>
          </div>

          {/* Testimonial Card */}
          <div className="relative min-h-[280px] flex items-center" data-id="element-215">
            <AnimatePresence mode="wait" data-id="element-216">
              <motion.div key={current} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} transition={{
              duration: 0.35
            }} className="w-full bg-dark-lighter rounded-2xl border border-white/5 p-8 md:p-12 text-center" data-id="element-217">
                {/* Stars */}
                <div className="flex items-center justify-center gap-1 mb-6" data-id="element-218">
                  {Array.from({
                  length: testimonials[current].rating
                }).map((_, i) => <Star key={i} size={18} className="text-gold fill-gold" data-id="element-219" />)}
                </div>

                {/* Quote */}
                <p className="text-white/80 font-inter text-lg md:text-xl leading-relaxed mb-8 italic" data-id="element-220">
                  "{testimonials[current].quote}"
                </p>

                {/* Author */}
                <div data-id="element-221">
                  <h4 className="text-white font-syne font-bold text-lg" data-id="element-222">
                    {testimonials[current].name}
                  </h4>
                  <p className="text-white/50 font-inter text-sm mt-1" data-id="element-223">
                    {testimonials[current].role}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8" data-id="element-224">
            <button onClick={prev} className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-gold hover:border-gold transition-colors" aria-label="Previous testimonial" data-id="element-225">
              <ChevronLeft size={20} data-id="element-226" />
            </button>

            {/* Dots */}
            <div className="flex items-center gap-2" data-id="element-227">
              {testimonials.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === current ? 'bg-gold w-6' : 'bg-white/20 hover:bg-white/40'}`} aria-label={`Go to testimonial ${i + 1}`} data-id="element-228" />)}
            </div>

            <button onClick={next} className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-gold hover:border-gold transition-colors" aria-label="Next testimonial" data-id="element-229">
              <ChevronRight size={20} data-id="element-230" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}